module.exports = __webpack_public_path__ + "img/dark-mud-decal-07.30162a57.png";